
import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsUpdateComponent from "../../components/News/NewsUpdate";

class NewsUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="News Update"
                            Breadcrumb={[
                                { name: "News", navigate: "/news" },
                                { name: "News Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsUpdate;
